module.exports = __webpack_public_path__ + "static/img/20240912_4.d950ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240912_4.png
// module id = Delc
// module chunks = 0